import { trackCustomLink } from '@sparknz/tracking';

import useAddBundles from 'components/shop/MobilePlans/hooks/useAddBundles';
import { useSelectedPlans } from 'components/shop/MobilePlans/providers';
import {
  MobilePlansDetails,
  SelectedPlan,
} from 'components/shop/MobilePlans/typings/plans';
import { buildAddBundlesInputBundles } from 'components/shop/MobilePlans/utils/buildAddBundlesInputBundles';

interface AddToCartProps {
  accountNumber?: string;
  plans: SelectedPlan[];
}

export const useAddToCart = (planCardsProducts: MobilePlansDetails) => {
  const { selectedPlans } = useSelectedPlans();
  const { addBundles, isAddingBundles } = useAddBundles();

  const addToCart = async ({ accountNumber, plans }: AddToCartProps) => {
    trackCustomLink('Add to cart');
    const bundles = buildAddBundlesInputBundles({
      accountNumber,
      selectedPlans: plans,
    });
    await addBundles({ bundles, planCardsProducts });
  };

  const addSelectedPlansToCart = async () =>
    addToCart({ plans: selectedPlans });

  return { isAddingBundles, addToCart, addSelectedPlansToCart };
};
